export default "__VITE_ASSET__Di1dgA1n__"